import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
export function CVRSystem() {
  const steps = [{
    letter: 'C',
    title: 'CALMAR',
    desc: 'Cómo preparar transiciones y eliminar explosiones innecesarias antes de que ocurran.'
  }, {
    letter: 'V',
    title: 'VINCULAR',
    desc: 'Cómo conectar con tu hijo antes de exigir, incluso en plena crisis.'
  }, {
    letter: 'R',
    title: 'REDIRIGIR',
    desc: 'Cómo dar una instrucción que tu hijo realmente pueda procesar y obedecer.'
  }];
  return <section className="py-10 md:py-20 px-5 bg-brand-cream" data-id="element-24">
      <div className="max-w-5xl mx-auto" data-id="element-25">
        <FadeIn data-id="element-26">
          <div className="text-center mb-8" data-id="element-27">
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-brand-navy mb-4" data-id="element-28">
              Presentamos el Método CVR:
            </h2>
            <p className="font-sans text-xl text-slate-600" data-id="element-29">
              Tres pasos simples para momentos reales.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-30">
          <div className="w-full max-w-3xl mx-auto mb-8" data-id="element-31">
            <img src="https://cdn.magicpatterns.com/uploads/4UGZKsbaeP1PBFAdCGaDyz/MOCKUP_COMPRIMIDO.png" alt="Calma en Casa - Guía y materiales" className="w-full h-auto rounded-2xl shadow-xl" data-id="element-32" />
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-4 mb-8" data-id="element-33">
          {steps.map((step, index) => <FadeIn key={index} delay={0.3 + index * 0.1} data-id="element-34">
              <div className="bg-white h-full p-8 rounded-2xl shadow-md border border-slate-100 flex flex-col items-center text-center" data-id="element-35">
                <div className="w-16 h-16 bg-brand-navy rounded-full flex items-center justify-center mb-6 shrink-0" data-id="element-36">
                  <span className="font-serif text-3xl text-white" data-id="element-37">
                    {step.letter}
                  </span>
                </div>
                <h3 className="font-sans font-bold text-xl text-brand-navy mb-3" data-id="element-38">
                  {step.title}
                </h3>
                <p className="font-sans text-slate-600 leading-relaxed text-sm md:text-base" data-id="element-39">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-40">
          <p className="text-center italic text-slate-600 mb-8 font-medium" data-id="element-41">
            Miles de madres ya lo están aplicando. Tú puedes empezar hoy.
          </p>
          <CTAButton mainText="SÍ, QUIERO EL KIT DIGITAL CALMA EN CASA" subText="Acceso inmediato al Sistema CVR por solo $7" data-id="element-42" />
        </FadeIn>
      </div>
    </section>;
}